import smartSolveApi from './instances/smartsolve';
import { POWERBI_ENTITY_NAME } from '../constants/PowerBIConstants';

export const initiatePowerBIImport = async (file, recordId) => {
  const formData = new FormData();

  formData.append('FileDescription', '');
  formData.append('FileStream', file);
  formData.append('EntityName', POWERBI_ENTITY_NAME);
  formData.append('ItemId', recordId);

  try {
    const response = await smartSolveApi.post('/report/import', formData);

    return response.data;
  } catch (e) {
    throw new Error(`initiatePowerBIImport'() failed: ${e}`);
  }
};

export const exportPowerBIReports = async (itemIds, exportType) => {
  try {
    const response = await smartSolveApi.post('/report/export', {
      entityName: POWERBI_ENTITY_NAME,
      itemIds,
      exportType,
    });

    return response.data;
  } catch (e) {
    throw new Error(`exportPowerBIReports'() failed: ${e}`);
  }
};

export const getPowerBIImportStatus = async (importId, fileName, itemId) => {
  try {
    const response = await smartSolveApi.post('/report/import/status', {
      importId,
      fileName,
      entityName: POWERBI_ENTITY_NAME,
      itemId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getGroupReports'() failed: ${e}`);
  }
};

export const getEmbedReport = async (itemId, getUnpublished = false, editReport = false) => {
  try {
    const response = await smartSolveApi.post('/report/embed', {
      entityName: POWERBI_ENTITY_NAME,
      itemId,
      getUnpublished: Boolean(getUnpublished),
      editReport,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getEmbedReport'() failed: ${e}`);
  }
};

export const publishPowerBIRecords = async (itemIds) => {
  try {
    const response = await smartSolveApi.post('/report/publish', {
      entityName: POWERBI_ENTITY_NAME,
      itemIds,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getEmbedReport'() failed: ${e}`);
  }
};

export const unpublishPowerBIRecord = async (itemId) => {
  try {
    const response = await smartSolveApi.post('/report/unpublish', {
      entityName: POWERBI_ENTITY_NAME,
      itemId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`unpublishPowerBIRecord'() failed: ${e}`);
  }
};

export const getDatasetList = async () => {
  try {
    const response = await smartSolveApi.post('/report/groupdatasets', {});

    return response.data;
  } catch (e) {
    throw new Error(`getDatasetList'() failed: ${e}`);
  }
};

export const getReportsList = async () => {
  try {
    const response = await smartSolveApi.post('/report/groupreports', {});

    return response.data;
  } catch (e) {
    throw new Error(`getReportsList'() failed: ${e}`);
  }
};

export const getReportCreationEmbedData = async (payload) => {
  try {
    const response = await smartSolveApi.post('/report/create', payload);

    return response.data;
  } catch (e) {
    throw new Error(`getReportCreationEmbedData'() failed: ${e}`);
  }
};

export const attachNewReport = async (itemId, reportId, reportName) => {
  try {
    const response = await smartSolveApi.post('/report/attach', {
      itemId,
      reportId,
      entityName: POWERBI_ENTITY_NAME,
      reportName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`attachNewReport'() failed: ${e}`);
  }
};

export const getExportStatus = async (items) => {
  try {
    const { data, headers } = await smartSolveApi.post(
      '/report/export/status',
      {
        items,
      },
      {
        responseType: 'blob',
      }
    );

    return { data, headers };
  } catch (e) {
    throw new Error(`getExportStatus'() failed: ${e}`);
  }
};
